


























import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.kitchen.type",
            inputName: "kitchen-setup",
            specificId: uuidv4() as string
        };
    },
    computed: {
        kitchenSetup: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("usa_installed"),
                    "value": "USA_INSTALLED"
                },
                {
                    "label": this.$t("usa_uninstalled"),
                    "value": "USA_UNINSTALLED"
                },
                {
                    "label": this.$t("usa_semi_equipped"),
                    "value": "USA_SEMI_EQUIPPED"
                },
                {
                    "label": this.$t("usa_hyper_equipped"),
                    "value": "USA_HYPER_EQUIPPED"
                },
                {
                    "label": this.$t("installed"),
                    "value": "INSTALLED"
                },
                {
                    "label": this.$t("uninstalled"),
                    "value": "UNINSTALLED"
                },
                {
                    "label": this.$t("semi_equipped"),
                    "value": "SEMI_EQUIPPED"
                },
                {
                    "label": this.$t("hyper_equipped"),
                    "value": "HYPER_EQUIPPED"
                }
            ];
        }
    },
    methods: {
        updateValue: function(kitchenSetupValue: string): void {
            if (kitchenSetupValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": kitchenSetupValue});
            }
        }
    },
});

